import { NgModule } from '@angular/core';
import { BuColumnsModule } from './bu-columns/bu-columns.module';
import { BuSectionModule } from './bu-section/bu-section.module';
import { BuContainerModule } from './bu-container/bu-container.module';
import { BuLevelModule } from './bu-level/bu-level.module';
import { BuButtonModule } from './bu-button/bu-button.module';
import { BuTagModule } from './bu-tag/bu-tag.module';
import { BuBoxModule } from './bu-box/bu-box.module';
import { BuDeleteModule } from './bu-delete/bu-delete.module';
import { BuNotificationModule } from './bu-notification/bu-notification.module';
import { BuImageModule } from './bu-image/bu-image.module';
import { BuProgressModule } from './bu-progress/bu-progress.module';
import { BuIconModule } from './bu-icon/bu-icon.module';
import { BuHeroModule } from './bu-hero/bu-hero.module';
import { BuMediaModule } from './bu-media/bu-media.module';
import { BuContentModule } from './bu-content/bu-content.module';
import { BuFooterModule } from './bu-footer/bu-footer.module';
import { BuTileModule } from './bu-tile/bu-tile.module';
import { BuCardModule } from './bu-card/bu-card.module';
import { BuDropdownModule } from './bu-dropdown/bu-dropdown.module';
import { BuMessageModule } from './bu-message/bu-message.module';
import { BuMenuModule } from './bu-menu/bu-menu.module';
import { BuTabsModule } from './bu-tabs/bu-tabs.module';
import { BuNavbarModule } from './bu-navbar/bu-navbar.module';
import { BuBreadcrumbModule } from './bu-breadcrumb/bu-breadcrumb.module';

@NgModule({
  imports: [
    BuColumnsModule,
    BuSectionModule,
    BuContainerModule,
    BuContentModule,
    BuLevelModule,
    BuHeroModule,
    BuMediaModule,
    BuFooterModule,
    BuTileModule,
    BuButtonModule,
    BuTagModule,
    BuBoxModule,
    BuDeleteModule,
    BuNotificationModule,
    BuImageModule,
    BuProgressModule,
    BuIconModule,
    BuCardModule,
    BuDropdownModule,
    BuMessageModule,
    BuMenuModule,
    BuTabsModule,
    BuNavbarModule,
    BuBreadcrumbModule
  ],
  declarations: [],
  exports: [
    BuColumnsModule,
    BuSectionModule,
    BuContainerModule,
    BuContentModule,
    BuLevelModule,
    BuHeroModule,
    BuMediaModule,
    BuFooterModule,
    BuTileModule,
    BuButtonModule,
    BuTagModule,
    BuBoxModule,
    BuDeleteModule,
    BuNotificationModule,
    BuImageModule,
    BuProgressModule,
    BuIconModule,
    BuCardModule,
    BuDropdownModule,
    BuMessageModule,
    BuMenuModule,
    BuTabsModule,
    BuNavbarModule,
    BuBreadcrumbModule
  ]
})
export class Angular2BulmaModule { }
